<div class="session-plan-area col-sm-12 h-100 p-2" role="document">
  <!-- Preloader -->
  <div class="loader-mask" *ngIf="loader == true">
    <div class="loader">
      <div></div>
      <div></div>
    </div>
  </div>
  <!-- Preloader -->
  <div class="h-100 bg-black">
    <div class="header bg-white">
      <h5 class="modal-title cursorArrow">
        Intelligent Assistant <fa-icon class="fas icon-black iconStyle pr-2" title="clear"
          (click)="clearChatGPTstorage()" [ngClass]="{ hidden: !assistantToken }" [icon]="faTrashAlt"></fa-icon>
      </h5>
      <!-- <button (click)="checkCredits()">Credits</button> -->
    </div>

    <div class="row promptsDropdown" *ngIf="assistantTool != 'RECON'" >
      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10  pr-2">
        <div class="dropdown">
          <button class="btn btn-default btn-sm btn-block dropdown-toggle" [ngClass]="{ dis: !assistantToken }"
            type="button" data-toggle="dropdown">
            <div class="row strict">
              <div class="col-xs-11 span-on-button">
                <span *ngIf="selectedQuery==''">Choose question</span>
                <span title="{{selectedQuery}}" *ngIf="selectedQuery!=''">{{selectedQuery}}</span>
              </div>
              <div class="col-xs-1 pull-right">
                <span class="caret"></span>
              </div>
            </div>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" style="width: 122% !important;">
            <li class="row strict cursorPointer" *ngFor="let a of assistantQuestions">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item"
                [ngClass]="{ dis: a.accessed == true }" title="{{a.question}}" style="padding-left: 4px;"
                (click)="a.accessed == false && getAnswerfromChatGPT(a)">
                {{a.query}}
              </div>
            </li>
            <!-- <li class="row strict">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item cursorPointer"
                (click)="getQuestiontype('Custom')" style="padding-left: 4px;">
                ----Choose to type custom query----
              </div>
            </li> -->
          </ul>
        </div>

      </div>
      <div class="col-xs-2 col-sm-2 col-xl-2 col-lg-2 col-md-2 pl-0">
        <button type="button" class="btn btn-default btn-block btn-sm float-right" (click)="openResponses()"
          [ngClass]="{ dis: !assistantToken }" title="send">
          <fa-icon class="fas icon-black" [icon]="faPaperPlane"></fa-icon>
        </button>
      </div>
    </div>

    <div class="body h-85 responsesArea1" *ngIf="assistantTool == 'RECON'">
      <div id="exportSheet" style="padding-left: 2px;"></div>
      <div id="exportSheet1" style="padding-left: 2px;"></div>
      <div id="exportSheet2" style="padding-left: 2px;"></div>
    </div>
    <div class="body h-79 responsesArea" *ngIf="assistantTool != 'RECON'">
      <div id="exportSheet" style="padding-left: 2px;"></div>
      <div id="exportSheet1" style="padding-left: 2px;"></div>
      <div id="exportSheet2" style="padding-left: 2px;"></div>
    </div>
    <div>
      <textarea placeholder="Probe further..." style="width: 100%; color: black !important;"
        [(ngModel)]="chatGPTquery" rows="4"></textarea>
      <button type="button" title="send" class="btn btn-default btn-block btn-sm float-right assistantSendButton"
        [ngClass]="{ dis: !chatGPTquery }" title="send" (click)="sendCustomPrompt('task')">
        <fa-icon class="fas icon-black" [icon]="faPaperPlane"></fa-icon>
      </button>
    </div>
    <!-- <div class="body h-90" *ngIf="assistantToken && assistantQuestionsType != 'Custom'"
      style="background-color: lightyellow; border: 0.5px solid black; overflow-x: auto;">
      <div id="exportSheet" style="padding-left: 2px;"></div>
    </div>
    <div class="body h-90 bodyStyles" *ngIf="!assistantToken">
      <h6><b>Since the Assistant (OpenAI) licence has not been furnished, you may cut and paste these prompts to seek
          answers from say OpenAI.</b></h6>
      <br>
      <br>
      <ul class="row strict" style="margin-left: 2px;" *ngFor="let a of config.questionsAnswers; let tabIndex = index">
        {{tabIndex+1}}. {{a.question}}-{{selectedEUTname}}-{{selectedEUTDescription}}
        <br><br>
      </ul>



    </div> -->
  </div>
 <!-- The conversations delete Confirm Message Modal -->
 <div class="modal fade" id="deleteAssistantMessagePopupModel" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal"
                >&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div class="form-element text-align-center">
                <!-- <label class="form-label marginbottom6px contentEllipsis text-align-center" title={{duplicateEntity}}>
                  {{duplicateEntity}}
                </label> -->
              </div>
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px text-align-center">Would you like to delete this conversation ?</label>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer text-align-center">
          <button type="button" class="btn btn-secondary modalActionBtn marginright10per" 
           (click)="confirmDelete()" data-dismiss="modal">{{
            'yes' | translate }}</button>
          <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
            {{ 'no' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
 <!-- The OpenAI tokens Message Modal -->
 <div class="modal fade" id="openAILimitExceededPopup" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal"
                >&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div class="form-element text-align-center">
                <!-- <label class="form-label marginbottom6px contentEllipsis text-align-center" title={{duplicateEntity}}>
                  {{duplicateEntity}}
                </label> -->
              </div>
              <div class="form-element text-align-center">
                <label class="form-label marginbottom6px text-align-center">The OpenAI usage limit has been exceeded!</label>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer text-align-center">
          <button type="button" class="btn btn-secondary modalActionBtn marginright10per" 
            data-dismiss="modal">{{
            'ok' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>